module.exports = __webpack_public_path__ + "static/media/02.1d84a41d.jpg";